import styles from "./aboutM3.module.css";
import LazyLoad from "react-lazyload";
import Button from "../button/button";
const AboutM3 = ({ resources }) => {
  return (
    <section className={`${styles.ctn} about-m3-ctn`}>
      <LazyLoad className="m3-active-desktop">
        <img
          className={styles.productImg}
          src={`${resources}m3challenge-m3.png`}
          alt=""
        />
      </LazyLoad>
      <div className={`${styles.contentBox} m3-active-desktop`}>
        <h2>
          APPLY FOR <span>FREE</span> CRANE-M3
        </h2>
        <h5>•  Join ZHIYUN Creators Club.</h5>
        <h5>•  Chance to Test the Latest CRANE M3 for Free.</h5>
        <h5>•  Get Future Products {"&"} Paid Projects.</h5>

        <div className={styles.buttons}>
          <Button type="main" href="https://explore.zhiyun-tech.com/en/club/project/detail/21975010642104320" target="_blank">Apply Now</Button>

          <Button type="general" href="https://www.zhiyun-tech.com/en/product/detail/479">Learn more about CRANE-M3</Button>
        </div>
      </div>

      <div className={`${styles.contentBox} m3-active-mobile`}>
        <div className={styles.mobileHeader}>
          <LazyLoad>
            <img
              className={styles.productImg}
              src={`${resources}m3challenge-m3.png`}
              alt=""
            />
          </LazyLoad>
          <h2>
            APPLY FOR <br /><span>FREE</span> <br />CRANE-M3
          </h2>
        </div>

        <h5>•  Join ZHIYUN Creators Club.</h5>
        <h5>•  Chance to Test the Latest CRANE M3 for Free.</h5>
        <h5>•  Get Future Products {"&"} Paid Projects.</h5>

        <div className={styles.buttons}>
          <Button type="main" href="https://explore.zhiyun-tech.com/en/club/project/detail/21975010642104320" target="_blank">Apply Now</Button>

          <Button type="general" href="https://explore.zhiyun-tech.com/en/club/project/detail/21975010642104320">Learn more about CRANE-M3</Button>
        </div>
      </div>
    </section>
  );
};

export default AboutM3;
